import { render, staticRenderFns } from "./bairong.vue?vue&type=template&id=e9fa8770&scoped=true"
import script from "./bairong.vue?vue&type=script&lang=js"
export * from "./bairong.vue?vue&type=script&lang=js"
import style0 from "./bairong.vue?vue&type=style&index=0&id=e9fa8770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fa8770",
  null
  
)

export default component.exports